(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Every Ajax call asks Shopify to render the `cart-items` section in the
  // same response, so one round trip both mutates the cart and returns the
  // fresh markup.
  const CART_SECTION = 'cart-items';

  class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      this.body = this.drawer.querySelector('[data-cart-body]');
      this.subtotal = this.drawer.querySelector('[data-cart-subtotal]');
      this.count = Number(document.querySelector('[data-cart-count]')?.textContent) || 0;

      // Desired quantity per line key, waiting to be sent. Taps update the
      // drawer at once and only the latest quantity for each line goes out.
      this.pending = new Map();
      this.flushing = false;
      this.bind();
    }

    bind() {
      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          this.open();
          return;
        }

        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }

        const step = event.target.closest('[data-cart-change]');
        if (step) {
          event.preventDefault();
          this.step(step.dataset.cartChange, Number(step.dataset.cartStep));
          return;
        }

        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          this.step(remove.dataset.cartRemove, -Infinity);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      // Add-to-cart forms post through the Ajax API so the drawer can open
      // in place. Without JS the form submits normally and Shopify redirects.
      document.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-cart-form]');
        if (!form) return;
        event.preventDefault();
        this.add(form);
      });
    }

    open() {
      this.drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.drawer.hidden = true;
      document.documentElement.style.overflow = '';
    }

    busy(state) {
      this.drawer.toggleAttribute('data-cart-busy', state);
    }

    async add(form) {
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      const body = new FormData(form);
      body.append('sections', CART_SECTION);

      // Open and count the new item straight away; the line itself arrives
      // with the response.
      this.updateCount(this.count + (Number(body.get('quantity')) || 1));
      this.busy(true);
      this.open();

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        if (response.ok) {
          this.render((await response.json()).sections);
        } else {
          await this.refresh();
        }
      } catch (error) {
        form.submit();
      } finally {
        this.busy(false);
        if (button) button.disabled = false;
      }
    }

    step(key, delta) {
      const line = this.body.querySelector(`[data-cart-line="${CSS.escape(key)}"]`);
      if (!line) return;

      const count = line.querySelector('[data-cart-line-count]');
      const current = Number(count.textContent);
      const quantity = Math.max(0, current + delta);

      count.textContent = quantity;
      line.hidden = quantity === 0;
      this.updateCount(this.count + quantity - current);

      this.pending.set(key, quantity);
      this.flush();
    }

    async flush() {
      if (this.flushing) return;
      this.flushing = true;
      this.busy(true);

      let sections = null;
      try {
        while (this.pending.size) {
          const [key, quantity] = this.pending.entries().next().value;
          this.pending.delete(key);

          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: CART_SECTION }),
          });
          sections = response.ok ? (await response.json()).sections : null;
        }

        // Only repaint once nothing is queued, so a stale response never
        // overwrites a tap the customer has already made.
        if (sections) {
          this.render(sections);
        } else {
          await this.refresh();
        }
      } finally {
        this.flushing = false;
        this.busy(false);
      }
    }

    async refresh() {
      const response = await fetch(`${window.location.pathname}?sections=${CART_SECTION}`);
      this.render(await response.json());
    }

    render(sections) {
      const markup = sections && sections[CART_SECTION];
      if (!markup) return;

      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = parsed.querySelector('[data-cart-items]');
      if (!fresh) return;

      this.body.innerHTML = fresh.innerHTML;
      if (this.subtotal) this.subtotal.textContent = fresh.dataset.cartTotal;
      this.updateCount(Number(fresh.dataset.cartCount));
    }

    updateCount(count) {
      this.count = count;
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === 0;
      });
    }
  }

  new CartDrawer();
  } catch(e) { console.error(e); }
})();

})();
